import { render } from "./InterstitialTwo.vue?vue&type=template&id=2973fe1e&scoped=true"
import script from "./InterstitialTwo.vue?vue&type=script&lang=js"
export * from "./InterstitialTwo.vue?vue&type=script&lang=js"

import "./InterstitialTwo.vue?vue&type=style&index=0&id=2973fe1e&lang=scss&scoped=true"

import exportComponent from "/Users/danny/Documents/projects/camden-mobile/microsite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2973fe1e"]])

export default __exports__